import React from 'react';

export interface ActiveIndex {
  index: number;
  setIndex: (index: number) => void;
  deleteIndex: (index: number) => void;
}

export const ActiveIndexContext = React.createContext<ActiveIndex | null>(null);
